import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module'; // Import Routing Module
import { AppComponent } from './app.component';
import { HomepageComponent } from './components/homepage/homepage.component'; // Import HomepageComponent
import { UsersComponent } from './components/users/users.component';
import { ComposersComponent } from './components/composers/composers.component';
import { SongsComponent } from './components/songs/songs.component';
import { RevelsComponent } from './components/revels/revels.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ResourceSongComponent } from './components/resource-song/resource-song.component';
import { ResourceRevelComponent } from './components/resource-revel/resource-revel.component';
import { ResourceComposerComponent } from './components/resource-composer/resource-composer.component';
import { ResourceService } from './services/resource.service';
import { LoginComponent } from './components/login/login.component';
import { HeaderComponent } from './components/header/header.component'; // Import HeaderComponent
import { FormsModule } from '@angular/forms'; // Import FormsModule
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog'; // Import MatDialogModule
import { UserDialogComponent } from './components/users/user-dialog.component'; // Import UserDialogComponent
import { SongDialogComponent } from './components/songs/song-dialog.component'; // Import SongDialogComponent
import { ComposerDialogComponent } from './components/composers/composer-dialog.component'; // Import SongDialogComponent
import { OverlayModule } from '@angular/cdk/overlay'; // Import OverlayModule
import { MatDividerModule } from '@angular/material/divider'; // Import MatDividerModule
import { RevelDialogComponent } from './components/revels/revel-dialog.component'; // Import RevelDialogComponent
import { ChoirResourceDialogComponent } from './components/homepage/choir-resource-dialog.component'; // Import RevelDialogComponent
import { MatTableModule } from '@angular/material/table'; // Import MatTableModule

@NgModule({
  declarations: [
    AppComponent,
    UsersComponent,
    ComposersComponent,
    SongsComponent,
    ResourceSongComponent,
    RevelsComponent,
    ResourceRevelComponent,
    HomepageComponent, // Declare HomepageComponent
    ResourceComposerComponent,
    LoginComponent, // Declare LoginComponent
    HeaderComponent, // Declare HeaderComponent here
    UserDialogComponent, // Ensure UserDialogComponent is declared
    SongDialogComponent, // Ensure SongDialogComponent is declared
    ComposerDialogComponent, // Ensure ComposerDialogComponent is declared
    RevelDialogComponent, // Ensure RevelDialogComponent is declared
    ChoirResourceDialogComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,  // Ensure AppRoutingModule is included here
    RouterModule.forRoot([]), // Add your routes here
    ReactiveFormsModule,
    FormsModule, // Add FormsModule here
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatDialogModule, // Ensure MatDialogModule is imported
    OverlayModule, // Add OverlayModule here
    MatDividerModule, // Add MatDividerModule here
    MatTableModule // Add MatTableModule here
  ],
  providers: [
    ResourceService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
